module.exports = __webpack_public_path__ + "assets/img/2.304fe275.png";